import { FC } from 'react';

import TrpLayout from '@/components/trp/TrpLayout';
import TrpTaxRefundSuccessContent from '@/components/trp/TrpTaxRefundSuccessContent';

interface Props {
  outStatCd: string;
}
type TrpTaxRefundSuccessPageProps = Props;

const TrpTaxRefundSuccessPage: FC<TrpTaxRefundSuccessPageProps> = (props) => {
  return (
    <TrpLayout>
      <TrpTaxRefundSuccessContent outStatCd={props.outStatCd} />
    </TrpLayout>
  );
};

export const getServerSideProps = async (context: any) => {
  const { req } = context;
  let parsedBody: any = { outStatCd: '' };
  if (req.method === 'POST') {
    let body = '';
    // Stream the request body data
    await new Promise((resolve: (value: unknown) => void) => {
      req.on('data', (chunk: string) => {
        body += chunk;
      });
      req.on('end', () => {
        resolve(undefined);
      });
    });

    const contentType = (req.headers['content-type'] as string | undefined) || '';
    try {
      if (contentType.includes('application/json')) {
        parsedBody = JSON.parse(body);
      } else {
        parsedBody = Object.fromEntries(new URLSearchParams(body));
      }
    } catch (_) {
      parsedBody = { outStatCd: '' };
    }
  }

  return {
    props: {
      outStatCd: parsedBody.outStatCd ?? ''
    }
  };
};

export default TrpTaxRefundSuccessPage;
